// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewSensorySessionId } from './BrewSensorySession';
import { operatorId } from './Operator';
import { foodSensoryAnalystStatus } from './FoodSensoryAnalystStatus';
import { z } from 'zod';
export const brewSensoryAnalystId = (z.number());
export const brewSensoryAnalyst = z.object({
    id: brewSensoryAnalystId,
    brew_sensory_session_id: brewSensorySessionId,
    operator_id: operatorId.nullable(),
    guest_name: z.string().nullable(),
    guest_email: z.string().nullable(),
    token: z.string(),
    status: foodSensoryAnalystStatus,
    consented_at: z.date().nullable(),
    invited_at: z.date(),
    completed_at: z.date().nullable(),
});
export const brewSensoryAnalystInitializer = z.object({
    id: brewSensoryAnalystId.optional(),
    brew_sensory_session_id: brewSensorySessionId,
    operator_id: operatorId.optional().nullable(),
    guest_name: z.string().optional().nullable(),
    guest_email: z.string().optional().nullable(),
    token: z.string().optional(),
    status: foodSensoryAnalystStatus.optional(),
    consented_at: z.date().optional().nullable(),
    invited_at: z.date().optional(),
    completed_at: z.date().optional().nullable(),
});
export const brewSensoryAnalystMutator = z.object({
    id: brewSensoryAnalystId.optional(),
    brew_sensory_session_id: brewSensorySessionId.optional(),
    operator_id: operatorId.optional().nullable(),
    guest_name: z.string().optional().nullable(),
    guest_email: z.string().optional().nullable(),
    token: z.string().optional(),
    status: foodSensoryAnalystStatus.optional(),
    consented_at: z.date().optional().nullable(),
    invited_at: z.date().optional(),
    completed_at: z.date().optional().nullable(),
});
//# sourceMappingURL=BrewSensoryAnalyst.js.map